<div>
<div id="wrap" class="wrap{{lvCls}}">
  <div *ngIf="report" id="wrap2">
    <div id="closeBtn">
      <span (click)="close();">×</span>
    </div>

    <div id="head_wrap" class="fontSize18">
      关键行动分析
    </div>

    <div id="subWrapOne">
      <div id="textBox"  class="fontSize14" [innerHtml]="tutor">

      </div>

      <div id="nextBtn" class="fontSize16" (click)="subWrapOneOut()">
        具体分析
        <img src="{{assetsRoute}}/picture/courselearning/arrow-right.png" alt="" id="arrow_right_1">
        <img src="{{assetsRoute}}/picture/courselearning/arrow-right.png" alt="" id="arrow_right_2">
      </div>
      <img src="{{assetsRoute}}/picture/casepractice/mindy.png" alt="" id="mindy" *ngIf="mode==1&&reportName!='协作'">
        <img src="{{assetsRoute}}/picture/casepractice/teacher2.png" alt="" id="teacher2" *ngIf="mode==1&&reportName=='协作'">
        <img src="{{assetsRoute}}/picture/casepracticepando/teacher1.png" alt="" id="teacher1" *ngIf="mode==2">
    </div>

    <div id="subWrapTwo">
      <div id="clickTip" class="fontSize14">
        点击下面关键行动，查看分析详情
      </div>
      <img src="{{assetsRoute}}/picture/casepractice/comment.png" alt="" class="tourReview" (click)="tourReviewBoxIn()" *ngIf="mode==1&&reportName!='协作'">
        <img src="{{assetsRoute}}/picture/casepractice/comment2.png" alt="" class="tourReview" (click)="tourReviewBoxIn()" *ngIf="mode==1&&reportName=='协作'">
        <img src="{{assetsRoute}}/picture/casepracticepando/teacher2.png" alt="" class="tourReview" (click)="tourReviewBoxIn()" *ngIf="mode==2">

    <div class="keyActionItem" (click)="analysisBoxIn(i)" *ngFor="let reportItem of report;let i=index" [ngClass]="{'keyActionItemOne':i%2==0,'keyActionItemTwo':i%2==1}">
        <div class="keyActionItemCircle keyActionItemCircle_{{mode}} keyActionItemCircle_{{mode}}_{{i}}"></div>
        <div class="keyActionItemText fontSize16">
          {{reportItem.name}}
        </div>
        <img src="{{assetsRoute}}/picture/casepracticepando/starYellow.png" alt="" class="star star1" *ngIf="reportItem.value>=1">
        <img src="{{assetsRoute}}/picture/casepracticepando/starYellow.png" alt="" class="star star2" *ngIf="reportItem.value>=2">
        <img src="{{assetsRoute}}/picture/casepracticepando/starYellow.png" alt="" class="star star3" *ngIf="reportItem.value>=3">
        <img src="{{assetsRoute}}/picture/casepracticepando/starYellow.png" alt="" class="star star4" *ngIf="reportItem.value>=4">
        <img src="{{assetsRoute}}/picture/casepracticepando/starYellow.png" alt="" class="star star5" *ngIf="reportItem.value>=5">

        <img src="{{assetsRoute}}/picture/casepracticepando/starGrey.png" alt="" class="star star1" *ngIf="reportItem.value<1">
        <img src="{{assetsRoute}}/picture/casepracticepando/starGrey.png" alt="" class="star star2" *ngIf="reportItem.value<2">
        <img src="{{assetsRoute}}/picture/casepracticepando/starGrey.png" alt="" class="star star3" *ngIf="reportItem.value<3">
        <img src="{{assetsRoute}}/picture/casepracticepando/starGrey.png" alt="" class="star star4" *ngIf="reportItem.value<4">
        <img src="{{assetsRoute}}/picture/casepracticepando/starGrey.png" alt="" class="star star5" *ngIf="reportItem.value<5">
      </div>


      <!-- <div id="transitionalText" class="fontSize18 lineHeight24" *ngIf="finished&&reportName!='授权'&&reportName!='组织与计划'">
        {{chuanjie}}
      </div>

      <div id="linkToPostSurvey" class="fontSize18 linkToPostSurvey{{mode}}" (click)="linkToPostSurvey()" *ngIf="learningTour.tour_meta_id == 1 && finished&&reportName!='授权'&&reportName!='组织与计划'">
        进入能力考核
      </div> -->

      <div id="space">

      </div>

    </div>

      <div id="tourReviewBox"  class="fontSize16 lineHeight24" [innerHtml]="tutor">

      </div>
      <div id="closeBtn1" (click)="tourReviewBoxOut()"></div>
      <div id="tourReviewShade" (click)="tourReviewBoxOut()"></div>

      <div id="bestPathBox" class="fontSize16 lineHeight24" [innerHtml]="optimum">

      </div>
      <div id="closeBtn2" (click)="bestPathOut()"></div>
      <div id="shade"></div>

    <div id="btnWrap" class="btnWrap{{mode}}">
      <div id="btnLeft" class="fontSize18" (click)="bestPathIn()">
        优秀示范

      </div>
      <div id="btnMiddle" class="fontSize18" (click)="redo()">
        重做一次
      </div>
      <div id="btnRight" class="fontSize18" (click)="goToList()">
        返回列表
      </div>
      <img src="{{assetsRoute}}/picture/casepracticeteam/btn_line.png" alt="" id="btnLine1">
      <img src="{{assetsRoute}}/picture/casepracticeteam/btn_line.png" alt="" id="btnLine2">
    </div>


    <div id="analysisBox" class="analysisBox{{mode}}" [@analysisBoxAnimation]="analysisBoxShow ? 'showAnalysisBox' : 'hideAnalysisBox'">
        <div id="analysisHead">
            <div class="fontSize18 lineHeight27" id="analysisHeadOne">{{currentName}}</div>
            <div class="fontSize14 lineHeight21" id="analysisHeadTwo">
                {{currentDescription}}
            </div>
            <div [@starAnimation]="starShow ? 'showStar' : 'hideStar'">
              <img src="{{assetsRoute}}/picture{{starPicUrl}}" alt="" class="starReport starReport1" *ngIf="currentTotal>=5">
              <img src="{{assetsRoute}}/picture{{starPicUrl}}" alt="" class="starReport starReport2" *ngIf="currentTotal>=4">
              <img src="{{assetsRoute}}/picture{{starPicUrl}}" alt="" class="starReport starReport3" *ngIf="currentTotal>=3">
              <img src="{{assetsRoute}}/picture{{starPicUrl}}" alt="" class="starReport starReport4" *ngIf="currentTotal>=2">
              <img src="{{assetsRoute}}/picture{{starPicUrl}}" alt="" class="starReport starReport5" *ngIf="currentTotal>=1">
            </div>
        </div>
        <div id="analysisContent" class="fontSize16 lineHeight24" [innerHtml]="currentAnalysis">

        </div>
        <div id="closeBtn3" (click)="analysisBoxOut()"></div>
    </div>

    <div id="analysisShade" (click)="analysisBoxOut()"></div>


  </div>
</div>
<!--新增等级说明-->
<app-report-level  *ngIf="isShowReportLv " [reportKAData] = "reportKAData"></app-report-level>
</div>



// WEBPACK FOOTER //
// ./src/app/case-practice-report-new-2/case-practice-report-new-2.component.html